import { JSX } from 'solid-js';

import { onCopy } from '../../utils';
interface CopyInputProps {
  /** 输入框的值 */
  value: string;
  /** 输入框标签 */
  label?: string;
  /** 自定义CSS类名 */
  class?: string;
  children?: JSX.Element;
  showChildren?: boolean;
}

/**
 * 带复制功能的输入框组件
 */
function CopyInput(props: CopyInputProps) {
  // console.log(props.children);

  return (
    <div class={cx('flex items-center gap-2 border border-main3 p-2 rounded-lg', props.class)}>
      {props.children ?? (
        <div>
          <h3 class="text-sm text-neutral-main5">{props.label}</h3>
          <div class="break-all text-neutral-main1">{props.value}</div>
        </div>
      )}
      <Button class="ml-auto p-0 min-h-0" onClick={() => onCopy(props.value)}>
        <IconCopy class="size-5" />
      </Button>
    </div>
  );
}

export default CopyInput;
